package org.lennycodes.hldi.styles

import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.lennycodes.hldi.constants.HLDITheme
import com.varabyte.kobweb.compose.ui.graphics.Color
val ProgramCardStyle = CssStyle {
    base {
        Modifier
            .backgroundColor(HLDITheme.Colors.white)
            .borderRadius(12.px)
            .padding(8.px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 4.px,
                blurRadius = 12.px,
                color = Color.rgba(0, 0, 0, 0.1f)
            )
            .textAlign(TextAlign.Center)
            .transition(
                Transition.of(
                    property = "all",
                    duration = 0.3.s,
                    timingFunction = TransitionTimingFunction.Ease
                )
            )
    }

    hover {
        Modifier
            .backgroundColor(HLDITheme.Colors.accent)
            .translateY((-8).px)
            .boxShadow(
                offsetX = 0.px,
                offsetY = 8.px,
                blurRadius = 24.px,
                color = Color.rgba(0, 0, 0, 0.15f)
            )
    }
}
